import React, {type ReactElement} from 'react';

import * as S from './PageWithSidebar.styles';

type PageWithSidebarProps = {
  sidebar: ReactElement;
  children: ReactElement;
  sidebarStyle?: Record<string, string>;
  contentStyle?: Record<string, string>;
};

export const PageWithSidebar = ({
  sidebar,
  children,
  sidebarStyle,
  contentStyle,
}: PageWithSidebarProps) => {
  return (
    <S.PageWithSidebar>
      <S.InlineSidebar
        style={{
          ...sidebarStyle,
        }}>
        {sidebar}
      </S.InlineSidebar>
      <S.Content style={contentStyle}>{children}</S.Content>
    </S.PageWithSidebar>
  );
};
